module.exports = __webpack_public_path__ + "img/f28.df3a598d.png";